import Vue from 'vue'
import AppShortInfoCardComponent from './app-shortinfo-card.vue' 
import WechatTipComponent from './wechat-tip.vue' 

Vue.component('app-shortinfo-card', AppShortInfoCardComponent)
Vue.component('app-wechat-tip', WechatTipComponent)